(function () {
	'use strict';

	/**
	 * @ngdoc components
	 * @name mx.components:mxRating
	 * @module mx.components
	 * @restrict 'E'
	 * @scope {}
	 * @description Rating with stars components
	 * @param {string} label@ - Text to be displayed with rating
	 * @param {int} max@ - Maximum value
	 * @param {int} value=? - Current value
	 * @param {boolean} disabled=? - Specifies if control is disabled
	 * @param {boolean} readOnly=? - Specifies if control is in a read only mode
	 * @usage <mx-rating label='Raring is' value='3' max='5'></mx-rating>
	 * @usage <mx-rating label='Rate me' max='5' on-change="vm.value = value"></mx-rating>
	 */
	angular.module('mx.components').component('mxRating', {
		templateUrl: 'mx-rating/mx-rating.html',
		controller: RatingController,
		controllerAs: 'vm',
		bindings: {
			value: '=',
			max: '@',
			disabled: '<?',
			label: '@',
			readOnly: '<?',
			onChange: '&?',
		},
		require: {
			mxContainerCtrl: '?^^mxContainer',
		},
	});

	RatingController.$inject = ['$element', '$scope', 'mx.internationalization'];
	function RatingController($element, $scope, i18n) {
		var vm = this;
		var starsContainer;

		vm.$onInit = function () {
			if (!vm.max) {
				vm.max = 5;
			}
			vm._disabled = !!vm.disabled;
		};

		vm.$postLink = function () {
			starsContainer = $element.find('.mx-rating');
			updateStars(vm.value);

			starsContainer.on('click', '.mx-rating--star', function () {
				toggle($(this).data('index'));
			});

			if (vm.mxContainerCtrl) {
				vm.mxContainerCtrl.registerChild($scope);
			}
		};

		$scope.$watch('vm.value', function (newValue) {
			if (!isNaN(newValue)) {
				updateStars(newValue);
			}
		});

		function toggle(index) {
			if (vm._disabled !== true && vm.readOnly !== true) {
				var newVal = index + 1;
				$scope.$evalAsync(function () {
					vm.value = newVal;
				});
				updateStars(newVal);
				if (angular.isFunction(vm.onChange)) {
					$scope.$evalAsync(function () {
						vm.onChange({ value: newVal });
					});
				}
			}
		}

		function updateStars(newValue) {
			if (starsContainer) {
				var stars = [];
				for (var i = 0; i < vm.max; i++) {
					stars.push({ filled: i < newValue });
				}
				// This type of forming html was made because of Performance reason.
				starsContainer.html(
					stars
						.map(function (star, i) {
							return (
								'<md-icon ' +
								'class="material-icons mx-rating--star ' +
								(star.filled ? 'mx-rating--star-filled' : '') +
								'" ' +
								'data-index="' +
								i +
								'" ' +
								'role="presentation" ' +
								'aria-hidden="true"> ' +
								'star ' +
								'</md-icon>'
							);
						})
						.join('') +
						'<span class="mx-aria-only">' +
						i18n.getFormatted('components.mx-rating.ARIA', newValue, vm.max),
					'.</span>'
				);
			}
		}

		return vm;
	}
})();
